import { render, staticRenderFns } from "./select-primary.vue?vue&type=template&id=549427f8&scoped=true"
import script from "./select-primary.vue?vue&type=script&lang=js"
export * from "./select-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549427f8",
  null
  
)

export default component.exports